<!-- This is the default modal that will appear if you didn't create and set up a custom
modal correctly. It gives hints as to what else you need to do to get a new modal working -->
<template>
  <modal-structure>
    <template v-slot:header>
      Missing Modal
    </template>
    <template v-slot:content>
      <div>
        <p>
          You need to create a unique modal in the modals folder.
          Import it into the ContainerModal component and create a condition
          for it in the switch statement.
        </p>
      </div>
    </template>
  </modal-structure>
</template>

<script>
import ModalStructure from './ModalStructure'
export default {

  name: 'DefaultModal',
  components: {
    ModalStructure
  }
}
</script>
